import 'css-chunk:src/components/widgets/Video/Video.scss';export default {
  "Video": "_Video_17oqv_1",
  "duration": "_duration_17oqv_9",
  "playIcon": "_playIcon_17oqv_25",
  "video": "_video_17oqv_29"
};